{
  "cs-CZ": {
    "model": {
      "profile": {
        "id": "ID uživatele.",
        "userName": "Uživatelské jméno",
        "email": "E-mailová adresa",
        "emailConfirmed": "E-mailová adresa byla potvrzena.",
        "phoneNumber": "Telefonní číslo",
        "phoneNumberConfirmed": "Telefonní číslo bylo ověřeno.",
        "twoFactorEnabled": "Dvoufaktorová autentizace je aktivována.",
        "lockoutEnd": "Konec období zablokování.",
        "lockoutEnabled": "Funkce uzamčení povolena.",
        "accessFailedCount": "Počet neúspěšných pokusů o přístup.",
        "firstName": "Jméno",
        "lastName": "Příjmení",
        "picture": "Obrázek profilu",
        "organisationName": "Organizace",
        "name": "Jméno",
        "roles": "Role"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Potvrzeno"
      },
      "action": {
        "resetPassword.tooltip": "Pošlete uživateli e-mailem instrukce pro obnovení hesla."
      },
      "message": {
        "resetPassword.success": "Uživateli byl odeslán e-mail s instrukcemi, jak resetovat jeho heslo."
      }
    }
  }
}